import { useContent } from '@altify/utils';
import { content } from '../AiInsights.content';
import aiLogo from 'assets/images/aiInsigihtsLogo.svg';
import { Heading } from '@altify/components';
import appHelpers from 'utils/app-urls';

const cdnURL = appHelpers.getCDNUrl();
const closeImg = `${cdnURL}assets/navigation/close.svg`;

interface AiInsightsHeaderProps {
  onClose: () => void;
}

export function AiInsightsHeader({ onClose }: AiInsightsHeaderProps) {
  const localizedContent = useContent(content);

  return (
    <div className="flex items-center justify-between mb-2">
      <div className="flex items-center gap-2">
        <img
          src={aiLogo}
          alt={localizedContent.altAiLogo}
          className="h-8 w-8"
        />
        <Heading level={5}>{localizedContent.title}</Heading>
      </div>
      <img
        onClick={onClose}
        src={closeImg}
        alt={localizedContent.altClose}
        className="cursor-pointer"
      />
    </div>
  );
}
